import { isRenderedClip } from '@/audio/clipKinds';

/**
 * Determines whether the loop browser should stay at the arrangement tempo.
 * Knock-generated clips intentionally do not count: they use the default tempo
 * and should never make a new beat hard to start with a melody.
 */
export const tempoLockState = ({ tracks = [], sessionBpm, released = false } = {}) => {
  const hasLibraryLoop = tracks.some((track) => (
    (track.clips || []).some((clip) => !isRenderedClip(clip))
  ));

  return {
    active: !released && hasLibraryLoop,
    bpm: sessionBpm,
  };
};
